export function getdata() {
	var obj = {
		tableData: [],
		headData: [{
				title: "公司名称",
				prop: "gongsmc",
				width: 160,
				custom: true,

			},
			{
				title: "份数",
				prop: "piaojzs",
				width: "80",
				AmountFormat: true,
				custom:true
			},
			{
				title: "金额",
				prop: "jine",
				custom: true,
				width: "80",
				AmountFormat: true,
			},
			{
				title: "税额",
				prop: "shuie",
				width: "80",
				custom: true,

				AmountFormat: true,
			},
		],
		outputData: {
			exportType: "",
			shenbq: "",
		},
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		}
	}
	return obj
}
